export const createEnvironment = <
  MandatoryKey extends string,
  OptionalKeyWithDefaultValue extends { key: string; defaultValue: string }
>(
  mandatoryKeys: ReadonlyArray<MandatoryKey>,
  optionalKeysWithDefaultValue: ReadonlyArray<OptionalKeyWithDefaultValue>,
  prefix = ''
): Record<MandatoryKey | OptionalKeyWithDefaultValue['key'], string> => {
  const missingKeys = mandatoryKeys.filter((key) => {
    const envVar = process.env[`${prefix}${key}`];

    if (typeof envVar === 'undefined') {
      return true;
    }

    if (envVar === '') {
      return true;
    }

    return false;
  });

  if (missingKeys.length > 0) {
    throw new Error(
      `The following environment variables are missing: ${missingKeys.join(
        ', '
      )}`
    );
  }

  const environment = {} as Record<string, string>;

  mandatoryKeys.forEach((key) => {
    environment[key] = process.env[`${prefix}${key}`] as string;
  });

  optionalKeysWithDefaultValue.forEach(({ key, defaultValue }) => {
    environment[key] = process.env[`${prefix}${key}`] || defaultValue;
  });

  return environment;
};
